import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { IRoom } from "./iroom";
import { RoomService } from "./room.service";

@Injectable({
    providedIn: 'root'
})
export class RoomResolver implements Resolve<BaseRespone<{ pagination: PaginationResult, roomDetails: IRoom[] }>> {
    /**
     * Constructor
     */
    constructor(private _roomService: RoomService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, roomDetails: IRoom[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
            roomTypeId: Number(route.paramMap.get('roomTypeId'))
        };
        return this._roomService.getAllRooms(data);
    }
}